module.exports = __webpack_public_path__ + "img/weixin-official.d8934c22.png";